import React, { useEffect, useState } from 'react';
import ApplicantsTab from '../../../Atoms/Tabs/ApplicantsTab';
import OnlineForm from '../OnlineForm/OnlineForm';
import styles from './OnlineFormContainer.module.css';
import CustomizedSelect from '../../../Atoms/Inputs/CustomizedSelect';
import { useFetchApplicationByApplicantAndApplication } from '../../../../Hooks/SingleApplicant';
import { useParams } from 'react-router-dom';
import StatusContainer from '../../Custom/StatusContainer';
import FilledUnFilledText from '../../../Atoms/CustomizedAtoms/FilledUnFilledText';
import statusicon from '../../../../assets/Imagess/statusicon.svg';
import Loader from '../../Loader/Loader';
import StatusModal from '../../Settings/SettingsModal/StatusModal';

const OnlineFormContainer = ({
  applicant,
  isApplicant,
  isLoading,
  refetch,
}) => {
  const { id } = useParams();
  const [selectedTab, setSelectedTab] = useState(0);
  const [showStatusModal, setShowStatusModal] = useState(false);

  const [defaultApplication, setDefaultApplication] = useState('');
  const [selectedApplication, setSelectedApplication] = useState({});

  const [applicationId, setApplicationId] = useState('');

  const {
    data: applicationDataById,
    refetch: refetchApplication,
    isLoading: isLoadingApplication,
  } = useFetchApplicationByApplicantAndApplication(
    id,
    applicationId?.value || defaultApplication?.applicationId,
  );
  const data1 = applicant?.applications?.filter(
    (item) => item.startYourApplication === 0,
  );
  const data2 = applicant?.applications?.filter(
    (item) => item.startYourApplication === 1,
  );
  const data3 = applicant?.applications?.filter(
    (item) => item.startYourApplication === 2,
  );

  useEffect(() => {
    if (data1 && data1?.length > 0) {
      setSelectedTab(0);
    } else if (data2 && data2?.length > 0) {
      setSelectedTab(1);
    } else {
      setSelectedTab(2);
    }
  }, [applicant]);

  useEffect(() => {
    if (!applicationId) {
      if (selectedTab === 0 && data1 && data1.length > 0) {
        setDefaultApplication(data1[0]);
      } else if (selectedTab === 1 && data2 && data2.length > 0) {
        setDefaultApplication(data2[0]);
      } else if (selectedTab === 2 && data3 && data3.length > 0) {
        setDefaultApplication(data3[0]);
      }
    }
  }, [data1, data2, data3]);

  useEffect(() => {
    setApplicationId('');
  }, [selectedTab]);

  useEffect(() => {
    setSelectedApplication(
      applicant?.applications?.find(
        (item) => item.applicationId == applicationId?.value,
      ),
    );
  }, [applicationId]);

  const selectedOptions =
    selectedTab == 0
      ? data1
        ? data1?.map((option) => ({
            value: option.applicationId,
            text:
              option.fieldOfInterest_Display ||
              option.programOfInterest_Display,
          }))
        : []
      : selectedTab == 1
        ? data2
          ? data2?.map((option) => ({
              value: option.applicationId,
              text:
                option.fieldOfInterest_Display ||
                option.programOfInterest_Display,
            }))
          : []
        : data3
          ? data3?.map((option) => ({
              value: option.applicationId,
              text:
                option.fieldOfInterest_Display ||
                option.programOfInterest_Display,
            }))
          : [];

  useEffect(() => {
    refetchApplication(
      id,
      applicationId?.value || defaultApplication?.applicationId,
    );
  }, [applicationId]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['onlinform-container']}>
      <div className={styles['tab-form-container']}>
        {isApplicant ? (
          <div className={styles['tab-container']}>
            {data1?.length > 0 && (
              <ApplicantsTab
                text='Undergraduate'
                active={selectedTab === 0}
                handleOnClick={() => setSelectedTab(0)}
              />
            )}
            {data2?.length > 0 && (
              <ApplicantsTab
                text='Graduate'
                active={selectedTab === 1}
                handleOnClick={() => setSelectedTab(1)}
              />
            )}
            {data3?.length > 0 && (
              <ApplicantsTab
                text='Visiting'
                active={selectedTab === 2}
                handleOnClick={() => setSelectedTab(2)}
              />
            )}
          </div>
        ) : (
          ''
        )}

        <div className={styles['applicationTab-subcontainer']}>
          <div className={styles['tab-subcontainer']}>
            {isApplicant ? (
              <div className={styles['select_subcontainer']}>
                {' '}
                <h3>Select Application: </h3>
                <CustomizedSelect
                  placeholder={
                    defaultApplication?.fieldOfInterest_Display ||
                    defaultApplication?.programOfInterest_Display ||
                    'Select Application'
                  }
                  noborder={true}
                  options={selectedOptions}
                  value={applicationId || defaultApplication}
                  onChange={setApplicationId}
                  width='200px'
                  unClear
                />
              </div>
            ) : (
              ' '
            )}
            {/* {applicant?.applications &&
              applicant?.applications[0]?.statusText === "Converted" && (
                <StatusContainer
                  status={
                    applicant?.applications &&
                    applicant?.applications[0]?.statusText
                  }
                />
              )} */}
            <div className={styles['details-subcontainer']}>
              {isApplicant && (
                <div>
                  <h4>Program:</h4>{' '}
                  <h5>
                    <FilledUnFilledText
                      required={true}
                      data={
                        selectedApplication?.programOfInterest_Display ||
                        defaultApplication?.programOfInterest_Display
                      }
                    />
                  </h5>
                </div>
              )}

              {applicant?.intersted?.fieldOfInterest_Display && (
                <div>
                  <h4>Field of Interest:</h4>{' '}
                  <h5>
                    <FilledUnFilledText
                      required={true}
                      data={applicant?.intersted?.fieldOfInterest_Display}
                    />
                  </h5>
                </div>
              )}

              <div>
                <h4>Status:</h4>
                <h5>
                  <StatusContainer
                    status={
                      isApplicant
                        ? selectedApplication?.statusText ||
                          defaultApplication?.statusText
                        : applicant?.intersted?.statusText
                    }
                  />
                </h5>
              </div>
            </div>
          </div>
          {selectedApplication?.statusText != 'Converted' &&
            defaultApplication?.statusText != 'Converted' && (
              <div
                onClick={() => setShowStatusModal(true)}
                className={styles['status-icon']}
              >
                <img src={statusicon} className='icon-img' alt='icon' /> Change
                Status
              </div>
            )}
        </div>
      </div>
      {isLoadingApplication ? (
        <Loader />
      ) : (
        <div>
          <OnlineForm
            applicant={applicant}
            applicationData={applicationDataById?.data}
            isApplicant={isApplicant}
            isLoading={isLoading}
            selectedApplication={selectedApplication || defaultApplication}
          />
        </div>
      )}{' '}
      {showStatusModal && (
        <StatusModal
          handleOnClose={() => setShowStatusModal(false)}
          title='Change Status'
          isApplicant={isApplicant}
          selected={[
            isApplicant
              ? {
                  foreignId:
                    applicationId?.value || defaultApplication?.applicationId,
                }
              : { id: applicant?.intersted?.studentId },
          ]}
          refetch={refetch}
          status={
            isApplicant
              ? selectedApplication?.statusText ||
                defaultApplication?.statusText
              : applicant?.intersted?.statusText
          }
          activeStatus={
            isApplicant
              ? selectedApplication?.applicationStatus ||
                defaultApplication?.applicationStatus
              : applicant?.intersted?.activeStatus
          }
        />
      )}
    </div>
  );
};

export default OnlineFormContainer;
